import { api } from '../../services/api.js';
const errorMessages = Object.freeze({
    SUPPLIER_RECORD_MODE_REQUIRED: 'حدّث الصفحة وحدد «من يتحملها؟» لكل بند مورد.',
    REFERENCE_IN_FINANCIAL_ITEMS_FORBIDDEN: 'تعذر فصل التوثيق عن الشراء. أعد تحميل الصفحة وراجع تصنيف البند.',
    INVALID_ITEM_TYPE: 'نوع البند غير مدعوم. اختر خدمة أو قطعة أو موردًا.',
    INVALID_ITEM_QUANTITY: 'الكمية يجب أن تكون أكبر من صفر.',
    INVALID_ITEM_AMOUNT: 'الكمية يجب أن تكون أكبر من صفر.',
    INVALID_ITEM_PRICE: 'السعر يجب أن يكون رقمًا موجبًا أو صفرًا.',
    INVALID_VISIT_ITEMS: 'تعذر قراءة بنود الزيارة. أعد تحميل الصفحة ثم حاول مرة أخرى.',
    INVALID_VISIT_ITEM: 'يوجد بند زيارة غير صالح. احذف البند وأضفه من جديد.',
    INVALID_VISIT_ACTION: 'إجراء الزيارة غير صالح. حدّث الصفحة ثم حاول مرة أخرى.',
    INSUFFICIENT_STOCK: 'الكمية المطلوبة غير متوفرة في المخزون.',
    REQUEST_KEY_REQUIRED: 'تعذر تأكيد طلب الحفظ. أعد المحاولة.',
    REQUEST_KEY_CONFLICT: 'تمت إعادة استخدام طلب الحفظ ببيانات مختلفة. حدّث الصفحة ثم راجع آخر البيانات قبل الحفظ.',
    IDEMPOTENCY_KEY_REQUIRED: 'تعذر تأكيد طلب السداد. أعد المحاولة.',
    IDEMPOTENCY_KEY_CONFLICT: 'تمت محاولة إعادة استخدام نفس طلب السداد ببيانات مختلفة. حدّث الصفحة ثم أعد العملية.',
    LEGACY_IDEMPOTENCY_KEY_UNVERIFIABLE: 'لا يمكن التحقق من طلب قديم بالمفتاح نفسه. أنشئ طلبًا جديدًا بعد مراجعة البيانات.',
    PAYMENT_AMOUNT_MUST_BE_POSITIVE: 'مبلغ السداد يجب أن يكون أكبر من صفر.',
    INVALID_PAYMENT_METHOD: 'طريقة السداد غير مدعومة.',
    FINAL_TOTAL_MUST_BE_POSITIVE: 'الإجمالي النهائي يجب أن يكون صفرًا أو أكبر.',
    EXPECTED_TOTAL_REQUIRED: 'تعذر التحقق من الإجمالي النهائي. حدّث الصفحة ثم حاول مرة أخرى.',
    EXPECTED_TOTAL_PRECISION: 'الإجمالي النهائي يجب أن يطابق دقة هللتين.',
    EXPECTED_TOTAL_MISMATCH: 'تغيّر إجمالي الزيارة. حدّث الصفحة وراجع البنود قبل المتابعة.',
    FINAL_TOTAL_CONFLICT: 'يوجد إجمالي نهائي مختلف محفوظ لهذه الزيارة.',
    SUPPLIER_ID_REQUIRED: 'اختر المورد لبند الشراء أولاً.',
    EXPECTED_REVISION_REQUIRED: 'تعذر التحقق من آخر تعديل للزيارة. حدّث الصفحة ثم حاول مرة أخرى.',
    STALE_VISIT_REVISION: 'عدّل مستخدم آخر الزيارة. حدّث الصفحة وراجع آخر البيانات قبل الحفظ.',
    PRECONDITION_REQUIRED: 'تحتاج هذه العملية إلى نسخة محدثة من الزيارة. حدّث الصفحة ثم حاول مرة أخرى.',
    SYNC_V1_RETIRED: 'تم تحديث مسار الحفظ. حدّث الصفحة ثم أعد المحاولة.',
    DUPLICATE_CLIENT_KEY: 'يوجد بند مكرر في طلب الحفظ. احذف التكرار ثم حاول مرة أخرى.',
    CLIENT_KEY_REQUIRED: 'تعذر تثبيت هوية أحد البنود. أعد تحميل الصفحة ثم حاول مرة أخرى.',
    VISIT_FINALIZED_IMMUTABLE: 'الزيارة معتمدة ماليًا ولا يمكن تعديل بنودها.',
    VISIT_CLOSED_IMMUTABLE: 'الزيارة مغلقة تشغيليًا. استخدم استعادة الزيارة قبل تعديل البنود.',
    VISIT_STATUS_TRANSITION_REQUIRES_LIFECYCLE: 'تغيير حالة التسليم أو الأرشفة يتم عبر إجراء التسليم أو الاستعادة.',
    FINALIZED_VISIT_CANNOT_REOPEN: 'الزيارة المعتمدة ماليًا لا يمكن إعادة فتحها.',
    FINALIZED_VISIT_DELETE_FORBIDDEN: 'الزيارة المعتمدة ماليًا لا يمكن حذفها.',
    VISIT_WITH_PAYMENTS_DELETE_FORBIDDEN: 'لا يمكن حذف زيارة لها دفعات مسجلة.',
    VISIT_NOT_FINALIZED: 'اعتمد الإجمالي النهائي للزيارة قبل إصدار الفاتورة.',
    VISIT_CANCELLED: 'هذه الزيارة ملغاة ولا يمكن تعديلها أو السداد عليها.',
    ANOTHER_ACTIVE_VISIT_EXISTS: 'توجد زيارة نشطة أخرى لهذه المركبة.',
    ACTIVE_VISIT_EXISTS: 'توجد زيارة نشطة أخرى لهذه المركبة.',
    VISIT_NOT_FOUND: 'لم يتم العثور على الزيارة المطلوبة.',
    VEHICLE_NOT_FOUND: 'لم يتم العثور على المركبة المطلوبة.',
    PART_NOT_FOUND: 'لم يتم العثور على القطعة المطلوبة.',
    SUPPLIER_NOT_FOUND: 'لم يتم العثور على المورد المطلوب.',
    OPEN_VISIT_RPC_INVALID_RESPONSE: 'تعذر إنشاء الزيارة. أعد المحاولة.',
});
export const vehicleVisitErrorMessage = (error, fallback) => {
    const detail = error?.response?.data?.detail ?? error?.message;
    const code = typeof detail === 'object'
        ? String(detail?.code ?? detail?.error ?? '')
        : String(detail ?? '');
    const matched = Object.keys(errorMessages).find((knownCode) => code.includes(knownCode));
    return matched ? errorMessages[matched] : (code && code !== '[object Object]' ? code : fallback);
};
export const vehicleVisitCardApi = {
    save: (visitId, payload) => api.put(`/visits/${visitId}`, {
        ...payload,
        action: 'save',
    }),
    close: (visitId, payload) => api.put(`/visits/${visitId}`, {
        ...payload,
        action: 'close',
    }),
    reopen: (visitId) => api.put(`/visits/${visitId}`, {
        action: 'reopen',
    }),
    finalize: (visitId, payload = {}) => {
        const idempotencyKey = payload.idempotencyKey || payload.idempotency_key || `visit-finalize:${visitId}`;
        return api.post(`/visits/${visitId}/finalize`, {
            ...payload,
            idempotencyKey,
        }, {
            headers: {
                'Idempotency-Key': idempotencyKey,
            },
        });
    },
    recordPayment: (visitId, payload, idempotencyKey) => api.post(`/visits/${visitId}/payments`, {
        ...payload,
        idempotency_key: idempotencyKey,
        payment_id: idempotencyKey,
    }, {
        headers: {
            'Idempotency-Key': idempotencyKey,
        },
    }),
    archiveVehicle: (vehicleId) => api.put(`/vehicles/${vehicleId}`, { status: 'delivered' }),
};
